const nonRunnerKeys = ['NR', 'WD'];

export const isRunnerCode = raceOutcomeCode => !nonRunnerKeys.includes(raceOutcomeCode);

export const isRunner = ({ raceOutcomeCode }) => isRunnerCode(raceOutcomeCode);

export const duplicateArrayVals = sourceArr =>
    sourceArr
        .reduce((acc, el) => [...acc, el, el], []);



// WEBPACK FOOTER //
// ./src/js/horse/form/formTable/helper.js